import type {
  AuthResponse,
  ChangePasswordRequest,
  LoginRequest,
  PasswordResetPreview,
  PasswordResetRequest,
  PrivacyNotice,
  RegistrationResponse,
  RegisterRequest,
  ConfirmEmailVerificationRequest,
  ResendEmailVerificationRequest,
  RequestPasswordResetRequest,
  ValidatePasswordResetRequest,
  User as UserContract,
} from '@financial/shared';
import { api } from '../../lib/api';

export async function loginRequest(body: LoginRequest): Promise<AuthResponse> {
  const res = await api.post<AuthResponse>('/auth/login', body);
  return res.data;
}

export async function registerRequest(body: RegisterRequest): Promise<RegistrationResponse> {
  const res = await api.post<RegistrationResponse>('/auth/register', body);
  return res.data;
}

export async function confirmEmailVerificationRequest(
  body: ConfirmEmailVerificationRequest,
): Promise<AuthResponse> {
  const res = await api.post<AuthResponse>('/auth/email-verifications/confirm', body);
  return res.data;
}

export async function resendEmailVerificationRequest(
  body: ResendEmailVerificationRequest,
): Promise<RegistrationResponse> {
  const res = await api.post<RegistrationResponse>('/auth/email-verifications/resend', body);
  return res.data;
}

export async function fetchPrivacyNotice(): Promise<PrivacyNotice> {
  const res = await api.get<PrivacyNotice>('/auth/privacy-notice');
  return res.data;
}

export async function changePasswordRequest(body: ChangePasswordRequest): Promise<void> {
  await api.post('/auth/change-password', body);
}

export async function validatePasswordResetRequest(
  body: ValidatePasswordResetRequest,
): Promise<PasswordResetPreview> {
  const res = await api.post<PasswordResetPreview>('/auth/password-resets/validate', body);
  return res.data;
}

export async function resetPasswordRequest(body: PasswordResetRequest): Promise<void> {
  await api.post('/auth/password-resets/confirm', body);
}

export async function requestPasswordResetRequest(
  body: RequestPasswordResetRequest,
): Promise<RegistrationResponse> {
  const res = await api.post<RegistrationResponse>('/auth/password-resets/request', body);
  return res.data;
}

export async function fetchMe(): Promise<UserContract> {
  const res = await api.get<UserContract>('/auth/me');
  return res.data;
}

export async function logoutRequest(): Promise<void> {
  await api.post('/auth/logout');
}

export async function sendSupportRequest(input: {
  name: string;
  email: string;
  message: string;
  website?: string;
}): Promise<{ message: string }> {
  const res = await api.post<{ message: string }>('/support', input);
  return res.data;
}
